var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"action-button",class:[
    `action-button--theme-${_vm.theme}`,
    {
      'action-button-ac': _vm.ac,
      'action-button-disabled': _vm.disabled
    }
  ],on:{"click":_vm.onClick}},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }